// extracted by mini-css-extract-plugin
module.exports = {"noGames":"_a8d1bfc","modal":"_995300f","pageNotFoundText":"_638dfac","returnToMainPage":"_2d22ba4","oopsMessage":"_416b483","infoBackground":"_a3dc7ea"};